import { render, staticRenderFns } from "./SearchScope.vue?vue&type=template&id=d130dd2a&"
import script from "./SearchScope.vue?vue&type=script&lang=ts&"
export * from "./SearchScope.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports